import api from "../../index";

export const GetAllSourceApi = () => api.get('salesdashboard/getall-sales-source');
export const AddSourceApi = (data, header) => api.post('salesdashboard/add-update-sales-source', data, header);
export const DeleteSourceApi = (salesSourceId) => api.delete(`salesdashboard/delete-sales-source/${salesSourceId}`);